"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviewDomElement = void 0;
const getPreviewDomElement = () => {
    return document.getElementById('container');
};
exports.getPreviewDomElement = getPreviewDomElement;
